import React from "react";
import DetailInfo_settlementRegister from "./DetailInfo_settlementRegister";
import TableSettlmentRegister from "./tablePaymentSettlmentInfo";
import TablePaymentRequest from "../tablePaymentRequest";
import { any } from "prop-types";

export default function PaymentRequest() {
  return (
    <div>
      <TablePaymentRequest />
    </div>
  );
}
